module.exports = "<h2 class=\"sub-header-title\">{{'SIDE_NAV.SYSTEM_MGMT.REPLICATION' | translate}}</h2>\n<nav class=\"subnav\">\n  <ul class=\"nav sub-nav-bg-color\">\n    <li class=\"nav-item\">\n      <a class=\"nav-link\" routerLink=\"endpoints\" routerLinkActive=\"active\">{{'REPLICATION.ENDPOINTS' | translate}}</a>\n    </li>\n    <li class=\"nav-item\">\n      <a class=\"nav-link\" routerLink=\"rules\" routerLinkActive=\"active\">{{'REPLICATION.REPLICATION_RULE' | translate}}</a>\n    </li>\n  </ul>\n</nav>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/replication/replication-management/replication-management.component.html
// module id = 875
// module chunks = 0